export default [
    {
        path: '/products',
        name: 'products',
        meta: {
            layout: 'emptyLayout',
            requiresAuth: true,
            title: 'Страхові продукти',
            breadcrumb: 'Страхові продукти',
        },
        beforeEnter: (to, from, next) => {
            // if (!store.getters.IS_PARTNER_STATUS) {
                next();
            // } else {
            //     next({name: 'prime'})
            // }
        },
        component: () => import('../pages/products-page')
    },
    // {
    //     path: '/partners/create',
    //     name: 'create-partner',
    //     meta: {
    //         layout: 'profileLayout',
    //         requiresAuth: true,
    //         title: 'Створити точку продажу',
    //         breadcrumb: 'Створити точку продажу',
    //     },
    //     beforeEnter: (to, from, next) => {
    //         if (!store.getters.IS_PARTNER_STATUS) {
    //             next();
    //         } else {
    //             next({name: 'prime'})
    //         }
    //     },
    //     component: () => import('../views/partners/CreateEditPartner.vue')
    // },
    // {
    //     path: '/partners/:id',
    //     name: 'edit-partner',
    //     meta: {
    //         layout: 'profileLayout',
    //         requiresAuth: true,
    //         title: 'Редагувати точку продажу',
    //         breadcrumb: 'Редагувати точку продажу',
    //     },
    //     beforeEnter: (to, from, next) => {
    //         if (!store.getters.IS_PARTNER_STATUS) {
    //             next();
    //         } else {
    //             next({name: 'prime'})
    //         }
    //     },
    //     component: () => import('../views/partners/CreateEditPartner.vue')
    // },
]
